import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";

export default function ImpersonateLandingPage() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  const token = params.get("token");
  const exchanged = useRef(false);

  useEffect(() => {
    if (!token || exchanged.current) return;
    exchanged.current = true;
    (async () => {
      try {
        const { data } = await api.get(`/auth/impersonate?token=${token}`);
        sessionStorage.setItem("st_impersonate_token", data.access_token);
        sessionStorage.setItem("st_impersonate_user", JSON.stringify({ id: data.user_id, email: data.email }));
        window.location.href = "/";
      } catch {
        setError("Token ungültig oder abgelaufen.");
      }
    })();
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <p className="text-sm text-red-500">{error}</p>
          <button onClick={() => window.close()} className="mt-4 rounded-full h-10 px-6 bg-[#0A0A0A] text-white text-sm font-medium">
            Tab schließen
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-6 h-6 border-2 border-[#E5E5E5] border-t-[#0A0A0A] rounded-full animate-spin mx-auto mb-3" />
        <p className="text-sm text-[#999]">Einloggen als User...</p>
      </div>
    </div>
  );
}
